module.exports = __webpack_public_path__ + "static/specimen2-f4f9093693249a267cf8e89575b106e9.jpg";